import { Card } from 'components/Card'
import { FooterRoot } from 'components/Footer/Footer.styles'
import { styled } from 'stitches.config'

export const MyAccountRoot = styled('div', {
  backgroundColor: '$secondary-100',
  color: '$primary-800',

  paddingTop: '$2',

  '&': {
    [`${FooterRoot}`]: {
      borderTop: '12px solid transparent',
      borderBottom: 0,
      borderImage: 'url(/assets/pattern-footer-border-mobile.svg) 30',

      '@bp2': {
        borderImage: 'url(/assets/pattern-footer-border-desktop.svg) 30',
      },
    },
  },
})

export const UserLayoutCard = styled(Card, {
  padding: '$1 ',
  '@bp1': {
    padding: '$3 $4 $4',
  },
  height: '100%',
})

export const MyAccountContent = styled('div', {
  maxWidth: '$max',
  width: '100%',
  margin: 'auto',
  px: '$3',
  $$headerHeight: '80px',
  $$footerHeight: '373px',
  minHeight: 'calc(100vh - $$headerHeight - $$footerHeight - $14)',

  '@bp2': {
    px: '$14',
    minHeight: 'calc(100vh - $$footerHeight - $14)',
  },
})

export const TitleSection = styled('div', {
  display: 'none',
  paddingTop: '$2',

  '@bp2': {
    display: 'block',
  },
})

export const Content = styled('div', {
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  gap: '$2',

  '@bp2': {
    '&::before': {
      content: 'none',
    },
  },
})

export const Wrapper = styled('div', {
  marginTop: '0 !important',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '$2',
  height: '100%',

  '&': {
    [`${Content}`]: {
      flex: 1,
    },
  },

  '@bp2': {
    flexDirection: 'row',
    marginTop: '$5 !important',
  },
})
